import { ISimulationGeneration } from '../interfaces/self-serve/isimulation-generation';

const STORAGE_KEY = 'self_serve_simulation_generations';
export const SimulationGenerationLocalStorageUtil = {
  getSimulationGenerations(): ISimulationGeneration[] {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      const parsed: ISimulationGeneration[] = data ? JSON.parse(data) : [];
      return parsed.map((generation) => ({ ...generation, files: generation.files ?? [] }));
    } catch (err) {
      console.error('Failed to parse simulation generations:', err);
      return [];
    }
  },

  saveAllGenerations(generations: ISimulationGeneration[]): void {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(generations));
    } catch (err) {
      console.error('Failed to save simulation generations:', err);
    }
  },

  saveGeneration(generation: ISimulationGeneration): void {
    const normalized: ISimulationGeneration = { ...generation, files: generation.files ?? [] };
    const all = this.getSimulationGenerations();
    const index = all.findIndex((g) => g.callUuid === normalized.callUuid);
    if (index !== -1) {
      all[index] = normalized;
    } else {
      all.push(normalized);
    }
    this.saveAllGenerations(all);
  },
};
